import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../.providers/auth.service';
import { AngularFireDatabase, FirebaseListObservable, FirebaseObjectObservable } from 'angularfire2/database';
import { Enterprise } from '../.modal/enterprise';
import { User } from '../.modal/user';
import { Project } from '../.modal/project';
@Component({
	selector: 'app-home-page',
	templateUrl: './home-page.component.html',
	styleUrls: ['./home-page.component.css']
})
export class HomePageComponent implements OnInit {
	updateUserOnLogin = false;
	users: FirebaseListObservable<any>;
	items: FirebaseListObservable<any>;
	user: any;
	enterprise: Enterprise;
	userData: FirebaseListObservable<any>;
	projects: FirebaseListObservable<any>;
	allData: any = [];
	constructor(private authService: AuthService, private router: Router, public db: AngularFireDatabase) {
		//this.users = db.list('users');
		//this.items = db.list('items');
	}
	updateUser(userGoogle) {
		var userData = new User();
		userData.fromGoogle(this.user);
		console.log(userData);
		this.db
			.object(this.user.uid)
			.update(userData)
			.then(data => {
				console.log(data);
			})
			.catch(error => {
				console.log(error);
			});
	}
	createUser(user, enterpriseId) {
		var userData = new User();
		userData.login = user.email;
		userData.enterprises = [enterpriseId];
		this.db
			.object(this.user.uid)
			.update(userData)
			.then(data => {
				console.log(data);
			})
			.catch(error => {
				console.log(error);
			});
		/*
		this.db
			.list('/' + user.uid)
			.push(userData)
			.then(item => {
				
				console.log(item);
			});*/
	}
	createEnterprise(users, type) {
		//create enterprise data
		this.enterprise = new Enterprise(users, type);
		this.db
			.object(this.enterprise.id)
			.update(this.enterprise)
			.then(data => {
				console.log(data);
				console.log('Enterprise id-' + this.enterprise.id);
				this.createUser(this.user, this.enterprise.id);
			})
			.catch(error => {
				console.log(error);
			});
		/*
		this.db
			.list('/')
			.push(this.enterprise)
			.then(item => {
				console.log('Enterprise id-' + item.key);
				this.createUser(this.user, item.key);
			});*/
	}
	registerUser() {
		this.db.list(this.user.uid).subscribe(data => {
			console.log(data);
			if (data == null || data.length == 0) {
				var userData = new User();
				userData.login = this.user.email;
				this.createEnterprise([this.user.uid], 'private');
			} else if (!this.updateUserOnLogin) {
				this.updateUserOnLogin = true;
				this.updateUser(data);
			}
			/*
			this.allData = data;
			if (this.allData.enterpriseId == null) {
				console.log(this.enterprise);
				this.db
					.list('/')
					.push(this.enterprise)
					.then(item => {
						
						console.log(item.key);
						this.allData.enterpriseId = item.key;
						console.log(this.allData);
						this.db.list('/').push(this.allData);
						//this.userData.update('enterpriseId', item.key);
						
					});
			}*/
		});
	}
	ngOnInit() {
		this.user = JSON.parse(localStorage.getItem('user'));
		//this.projects = this.db.list(this.user.uid + '/projects');
		//this.registerUser();
		//this.userData = this.db.list(this.user.uid);
		/*var data = this.db.list(this.user.uid);

		console.log(data.$ref.toJSON());
		data.data.forEach(item => {
			console.log(item);
		});

		 
			//.subscribe(data => {
			
			console.log(this.allData[2]);
			for (var i = 0; i < this.allData.length; i++) {
				console.log(this.allData[i].$key);
				if (this.allData[i].$key == 'projects') {
					this.projects = this.allData[i];
					console.log(this.projects);
					break;
				}
			}*/
	}
	logout() {
		this.authService.logout();
		this.router.navigate(['login']);
	}
}



// WEBPACK FOOTER //
// D:/OneDrive/Dev/firebase/alagatime_bootstrap/src/app/home-page/home-page.component.ts